<template>
  <div class="container">
    <v-card>
      <v-card-title>Ayuda del sistema</v-card-title>
      <v-card-text>
        <v-expansion-panels 
            popout 
            focusable 
            v-model="panel"
        >
            <v-expansion-panel>
                <v-expansion-panel-header>Creacion de Bins</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-img 
                        src="@/assets/images/crear-bins.png">
                    </v-img>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>Recepción de Bins</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-img 
                        src="@/assets/images/recepcion-bins.png">
                    </v-img>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>Despacho de Bins</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-img 
                        src="@/assets/images/despacho-bins.png">
                    </v-img>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>Dar de baja Bins</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-img 
                        src="@/assets/images/baja-bins.png">
                    </v-img>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>Cambiar planta de destino a Bins</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-img 
                        src="@/assets/images/cambio-bins.png">
                    </v-img>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>

    
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    props: {
      source: String,
    },
    data: () => ({
      panel: 0
    }),
    mounted() {
    },
    methods:{
      ...mapMutations(['actualizarBaseUrl']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'headers'])
    },
    components:{
    }
  }
</script>